import {
  GET_LOCALIZATIONS,
} from 'constants/localizations';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_LOCALIZATIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
